import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { SvgIcon } from '@material-ui/core/'
import { mdiCancel } from '@mdi/js'

import Link from '../../controls/Link'

class AccessUserEditLink extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    accessId: PropTypes.number.isRequired,
    isUserEnabled: PropTypes.bool.isRequired,
    linkText: PropTypes.string.isRequired,
  }

  static styles = (theme) => ({
    a: theme.a,
    disabled: {
      color: 'rgba(0, 0, 0, 0.54)',
    },
    disabledIcon: {
      color: 'rgba(0, 0, 0, 0.54)',
      marginLeft: theme.spacing(0.5),
      verticalAlign: 'middle',
    },
  })

  render() {
    const { classes, isUserEnabled } = this.props
    let linkClassName = classes.a
    if (!isUserEnabled) {
      linkClassName += ` ${classes.disabled}`
    }

    return (
      <Link
        to={`/dooraccess/${this.props.accessId}`}
        className={linkClassName}
      >
        {this.props.linkText}
        { !isUserEnabled && (
          <SvgIcon className={classes.disabledIcon}>
            <path d={mdiCancel} />
          </SvgIcon>
        )}
      </Link>
    )
  }
}

export default withStyles(AccessUserEditLink.styles)(AccessUserEditLink)
